import React from 'react';
import { FederationMembersPage } from '../../components/FederationMembersPage';
const members = [{
  name: 'Шалагін Михайло',
  role: 'Голова Тренерської ради',
  email: 'm.shalagin@umcf.org.ua'
}, {
  name: 'Перлова Наталія',
  role: 'Тренер',
  email: 'kazbekovs12@gmail.com'
}, {
  name: 'Побережець Микола',
  role: 'Тренер',
  email: 'm.poberezets@umcf.org.ua'
}];
export function CoachCouncil() {
  return <FederationMembersPage title="Тренерська рада" subtitle="Тренерська рада скельного комітету ФАіСУ" members={members} data-id="element-560" />;
}